import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag, X } from 'lucide-react';
const FAKE_NAMES = ['Carlos M.', 'María L.', 'Andrés R.', 'Sofía G.', 'Diego P.', 'Valentina H.', 'Mateo S.', 'Camila F.', 'Santiago T.', 'Isabella V.', 'Sebastián D.', 'Luciana B.', 'Nicolás A.', 'Gabriela C.', 'Daniel E.', 'Paula J.', 'Alejandro K.', 'Mariana N.', 'Javier O.', 'Andrea Q.'];
const CITIES = ['CDMX', 'Bogotá', 'Lima', 'Buenos Aires', 'Madrid', 'Barcelona', 'Medellín', 'Santiago', 'Monterrey', 'Quito'];
function getRandomItem<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
function getRandomMinutesAgo(): string {
  const mins = Math.floor(Math.random() * 12) + 1;
  return `hace ${mins} min`;
}
export function RecentPurchasePopup() {
  const [visible, setVisible] = useState(false);
  const [purchaseData, setPurchaseData] = useState({
    name: '',
    city: '',
    time: ''
  });
  useEffect(() => {
    const showPopup = () => {
      setPurchaseData({
        name: getRandomItem(FAKE_NAMES),
        city: getRandomItem(CITIES),
        time: getRandomMinutesAgo()
      });
      setVisible(true);
      setTimeout(() => setVisible(false), 5000);
    };
    // First popup after 10 seconds
    const firstTimeout = setTimeout(() => {
      showPopup();
      // Subsequent popups every 45 seconds
      const interval = setInterval(showPopup, 45000);
      return () => clearInterval(interval);
    }, 10000);
    return () => clearTimeout(firstTimeout);
  }, []);
  return <AnimatePresence data-id="element-279">
      {visible && <motion.div initial={{
      x: -400,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -400,
      opacity: 0
    }} transition={{
      type: 'spring',
      damping: 25,
      stiffness: 200
    }} className="fixed bottom-4 left-4 z-[100] max-w-xs" data-id="element-280">
          <div className="bg-matrix-surface border border-matrix-primary/30 rounded-lg p-4 shadow-[0_0_20px_rgba(0,255,65,0.15)] backdrop-blur-sm" data-id="element-281">
            <button onClick={() => setVisible(false)} className="absolute top-2 right-2 text-matrix-muted hover:text-matrix-text transition-colors" data-id="element-282">
              <X className="w-3.5 h-3.5" data-id="element-283" />
            </button>

            <div className="flex items-start gap-3" data-id="element-284">
              <div className="w-10 h-10 rounded bg-matrix-primary/10 border border-matrix-primary/30 flex items-center justify-center shrink-0" data-id="element-285">
                <ShoppingBag className="w-5 h-5 text-matrix-primary" data-id="element-286" />
              </div>
              <div className="min-w-0" data-id="element-287">
                <p className="text-matrix-text text-sm font-semibold leading-tight" data-id="element-288">
                  {purchaseData.name}
                  <span className="text-matrix-muted font-normal text-xs ml-1" data-id="element-289">
                    — {purchaseData.city}
                  </span>
                </p>
                <p className="text-matrix-primary text-xs mt-0.5 font-medium" data-id="element-290">
                  Compró Mente Maestra
                </p>
                <div className="flex items-center justify-between mt-1.5" data-id="element-291">
                  <span className="text-matrix-orange font-bold text-sm" data-id="element-292">
                    $17.89
                  </span>
                  <span className="text-matrix-muted text-[10px]" data-id="element-293">
                    {purchaseData.time}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}